var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommunicationCards',{attrs:{"data":_vm.brokerCommunication,"title":'Broker'}}),_c('CommunicationCards',{attrs:{"data":_vm.clientCommunication,"title":'Client'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }